export default __webpack_public_path__ + "static/media/cheermeter-needle.d5e46aac.svg";